export default `/*
    Another Heta module
*/
`;